export function Stack ({children}) {
  return (
    <div className='flex flex-col gap-1'>
      {children}
    </div>
  )
}